import React from "react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "views/components/ui/Select";

const CategoryDropdown = ({
    categories,
    selectedCategoryId,
    selectedSubCategoryId,
    onCategoryChange,
    onSubCategoryChange,
}) => {
    const categoryArray = Object.values(categories);
    const currentCategory = categoryArray.find(
        (cat) => cat.name === selectedCategoryId
    );

    return (
        <div className="space-y-4">
            <div>
                <h3 className="font-medium text-gray-900 mb-2">Category</h3>
                <Select
                    value={selectedCategoryId}
                    onValueChange={onCategoryChange}
                >
                    <SelectTrigger className="w-full">
                        <SelectValue placeholder="Select a category" />
                    </SelectTrigger>
                    <SelectContent className="z-[100] bg-white border rounded-md shadow-lg max-h-[200px] overflow-y-auto">
                        {categoryArray.map((category) => (
                            <SelectItem
                                key={category.name}
                                value={category.name}
                                className="cursor-pointer hover:bg-gray-100 px-2 py-1.5"
                            >
                                {category.name}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>

            {selectedCategoryId &&
                currentCategory?.subCategories?.length > 0 && (
                    <div>
                        <h3 className="font-medium text-gray-900 mb-2">
                            Subcategory
                        </h3>
                        <Select
                            value={selectedSubCategoryId}
                            onValueChange={onSubCategoryChange}
                        >
                            <SelectTrigger className="w-full">
                                <SelectValue placeholder="Select a subcategory" />
                            </SelectTrigger>
                            <SelectContent className="z-[100] bg-white border rounded-md shadow-lg max-h-[200px] overflow-y-auto">
                                {currentCategory.subCategories.map(
                                    (subCategory) => (
                                        <SelectItem
                                            key={subCategory.name}
                                            value={subCategory.name}
                                            className="cursor-pointer hover:bg-gray-100 px-2 py-1.5"
                                        >
                                            {subCategory.name}
                                        </SelectItem>
                                    )
                                )}
                            </SelectContent>
                        </Select>
                    </div>
                )}
        </div>
    );
};

export default CategoryDropdown;
